import { Category } from '@@partner:types:app'
import React, { useCallback } from 'react'

import {
  useSortable,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import SortIcon from '@rsuite/icons/Sort'
import { SelectPicker } from 'rsuite'
import { GQL_ID } from '@@partner:types:graphql'
import DropzoneUploader from '@components/common/form/DropzoneUploader'
import { API_URL_UPLOAD_CATEGORY_ICON } from '@@partner:config/api'
import { UPLOAD_NAME_CATEGORY_ICON } from '@@partner:config/category'

type SubcategoryItemProps = {
  category: Category
  onChange: (category: Category) => void
  isSelected?: boolean
  onSelect?: (category: Category) => void
  level?: number
}

type PickerSize = {
  label: string
  value: string
}

const pickerSize: PickerSize[] = [
  { label: 'Обычный', value: 'standard' },
  { label: 'Двойной', value: 'double' },
  { label: 'Большой', value: 'big' }
]

export default function SubcategoryItem ({
  category,
  onChange,
  isSelected = false,
  onSelect,
  level = 2
}: SubcategoryItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: category.id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const handleChange = useCallback((values: Partial<Category>) => {
    onChange({
      ...category,
      ...values
    })
  }, [ onChange, category ])
  
  const handleUploadIcon = useCallback((
    icon_id: GQL_ID,
    url: string
  ) => {
    handleChange({
      icon_id: icon_id,
      icon: {
        url
      }
    })
  }, [ handleChange ])
  
  const handleCategoryClick = useCallback(() => {
    if (onSelect) {
      onSelect(category)
    }
  }, [ onSelect, category ])
  
  return (
    <div
      ref={setNodeRef}
      className={`SubcategoryItem SubcategoryItem--level-${level}${isSelected ? ' SubcategoryItem--selected' : ''}`}
      style={ style }
      onClick={handleCategoryClick}
    >
      <div className="SubcategoryItem__main">
        <div className="SubcategoryItem__image">
          {category.icon?.url ? (
            <img src={category.icon.url} alt={category.name} />
          ) : (
            <div className="SubcategoryItem__image-placeholder">
              <span>Нет изображения</span>
            </div>
          )}
        </div>
        
        <div className="SubcategoryItem__info">
          <div
            {...attributes}
            {...listeners}
            className='SubcategoryItem__header'
          >
            <div><SortIcon style={{ fontSize: '1rem' }} /></div>
            <h3 className="SubcategoryItem__title">{category.name}</h3>
          </div>
          
          <div className="SubcategoryItem__content">
            <div className='SubcategoryItem__size-selector'>
              <label>Размер</label>
              <SelectPicker
                data={pickerSize}
                value={category.preview_size ?? 'standard'}
                onChange={(value) => {
                  handleChange({
                    preview_size: value ?? 'standard'
                  })
                }}
                style={{ width: 120 }}
                placeholder="Размер"
                size="sm"
              />
            </div>
            <DropzoneUploader
              action={API_URL_UPLOAD_CATEGORY_ICON}
              name={UPLOAD_NAME_CATEGORY_ICON}
              onUploaded={handleUploadIcon}
              multiple={false}
              containerStyle={{
                height: 36,
                minHeight: undefined,
                width: 200,
                flex: 1
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
